import { useState } from 'react';
import { setInitialFtp } from '@/store/ftp';
import { useSettings } from '@/store/settings';
import { FTP_MAX, FTP_MIN, isValidFtp } from '@/store/settingsModel';
import { fmtNumber, useT } from '@/ui/i18n';

/** First start: the one and only time the rider types their FTP (afterwards only FTP tests change it). */
export function OnboardingPage() {
  const t = useT();
  const current = useSettings((s) => s.settings);
  // Riders migrating from an older version see their previous value prefilled.
  const [ftp, setFtp] = useState(current.updatedAt > 0 ? String(current.ftp) : '');
  const [kg, setKg] = useState(String(current.riderWeightKg));
  const [touched, setTouched] = useState(false);
  const w = Number(ftp);
  const m = Number(kg.replace(',', '.'));
  const valid = isValidFtp(w);
  const wkg = valid && m > 0 ? w / m : null;

  return (
    <main className="onboarding" data-testid="onboarding">
      <div className="onboarding-art">
        <img src="/icons/icon-512.png" alt="VeloStube" width={360} height={360} />
      </div>
      <form
        className="onboarding-form"
        onSubmit={async (e) => {
          e.preventDefault();
          setTouched(true);
          if (!valid) return;
          await setInitialFtp(w, Number.isFinite(m) ? m : undefined);
        }}
      >
        <h1>{t('onboarding.title')}</h1>
        <p className="lead">{t('onboarding.lead')}</p>
        <p className="once">{t('onboarding.once')}</p>
        <div className="onboarding-fields">
          <label className="field">
            {t('onboarding.ftp')}
            <input
              inputMode="numeric"
              autoFocus
              value={ftp}
              placeholder="z. B. 220"
              onChange={(e) => setFtp(e.target.value.replace(/[^0-9]/g, ''))}
              aria-invalid={touched && !valid}
              data-testid="onboarding-ftp"
            />
          </label>
          <label className="field">
            {t('onboarding.weight')}
            <input
              inputMode="decimal"
              value={kg}
              onChange={(e) => setKg(e.target.value.replace(/[^0-9.,]/g, ''))}
              data-testid="onboarding-weight"
            />
          </label>
        </div>
        <p className="hint">
          {wkg !== null ? (
            <span className="wkg">{t('onboarding.wkg', { wkg: fmtNumber(wkg, 2) })} · </span>
          ) : null}
          {touched && !valid ? t('onboarding.invalid', { min: FTP_MIN, max: FTP_MAX }) : t('onboarding.hint')}
        </p>
        <div>
          <button className="primary big" type="submit" data-testid="onboarding-submit">
            {t('onboarding.submit')}
          </button>
        </div>
      </form>
    </main>
  );
}
